/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import md5 from 'blueimp-md5';
import type School from 'linced-admin/models/school';

// Proto: schools.Group.
export default class Group extends Model {
  declare [Type]: 'schools/group';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare grouping: string;

  @hasMany('school', { async: true, inverse: 'groups' })
  declare schoolIds: AsyncHasMany<School>;

  @computed('schoolIds.content.[]')
  get schoolsArray() {
    return resolved(this.schoolIds);
  }

  @alias('schoolIds')
  declare schools: AsyncHasMany<School>;

  // image returns the URI to an autogenerated gravatar.
  @computed('id')
  get image() {
    return `https://gravatar.com/avatar/${md5(this.id!)}?d=identicon&f=y`;
  }
}
